import { LOAD_STATE } from '@shared/axios';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import {
    deleteHotSpotConfig,
    getHotSpotsConfig,
    saveHotSpotConfig,
} from '../hot-spot-api';

export const GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_CALLED = '@hotspot/GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_CALLED';
export const GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED = '@hotspot/GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED';
export const GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_FAILED = '@hotspot/GET_HOT_SPOTS_FOR_CUSTOMERS_ID_REQUEST_FAILED';
export const DELETE_HOT_SPOT_REQUEST_CALLED = '@hotspot/DELETE_HOT_SPOT_REQUEST_CALLED';
export const DELETE_HOT_SPOT_REQUEST_SUCCEEDED = '@hotspot/DELETE_HOT_SPOT_REQUEST_SUCCEEDED';
export const DELETE_HOT_SPOT_REQUEST_FAILED = '@hotspot/DELETE_HOT_SPOT_REQUEST_FAILED';
export const SAVE_HOT_SPOT_REQUEST_CALLED = '@hotspot/SAVE_HOT_SPOT_REQUEST_CALLED';
export const SAVE_HOT_SPOT_REQUEST_SUCCEEDED = '@hotspot/SAVE_HOT_SPOT_REQUEST_SUCCEEDED';
export const SAVE_HOT_SPOT_REQUEST_FAILED = '@hotspot/SAVE_HOT_SPOT_REQUEST_FAILED';

const formatCategoriesToOptions = categories => categories.map(category => ({
    value: `${category.id}`,
    label: category.name,
}));

const formatApiToHotSpot = hotSpot => ({
    ...hotSpot,
    selectedCategories: formatCategoriesToOptions(hotSpot.categories || []),
    startDate: hotSpot.start_date,
    endDate: hotSpot.end_date,
});

const formatApiDataToHotSpots = hotSpots => Object.values(hotSpots)
    .map(formatApiToHotSpot);

export const getRequestHotSpotData = (state, action) => {
    const filteredData = state.data.filter(hotSpot => hotSpot.id
            !== action.requestAction.hotSpot.id);
    const newHotSpot = {
        ...action.requestAction.hotSpot,
        id: action.payload.data.id,
        categories: action.payload.data.categories,
        created_by: action.payload.data.created_by,
    };
    const editedHotSpot = {
        ...action.requestAction.hotSpot,
        categories: action.payload.data.categories,
    };
    const isCreating = !action.requestAction.hotSpot.id;
    const hotSpot = isCreating ? newHotSpot : editedHotSpot;

    return [...filteredData, formatApiToHotSpot(hotSpot)];
};

export const getHotSpots = ({
    customerType, customerId, startDate, endDate,
}) => ({
    type: GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_CALLED,
    actionTypes: {
        success: GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED,
        fail: GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_FAILED,
    },
    config: getHotSpotsConfig({
        customerType, customerId, startDate, endDate,
    }),
});

export const deleteHotSpot = hotSpotId => ({
    type: DELETE_HOT_SPOT_REQUEST_CALLED,
    actionTypes: {
        success: DELETE_HOT_SPOT_REQUEST_SUCCEEDED,
        fail: DELETE_HOT_SPOT_REQUEST_FAILED,
    },
    config: deleteHotSpotConfig({
        hotSpotId,
    }),
    hotSpotId,
});

export const saveHotSpot = ({
    hotSpot,
}) => ({
    type: SAVE_HOT_SPOT_REQUEST_CALLED,
    actionTypes: {
        success: SAVE_HOT_SPOT_REQUEST_SUCCEEDED,
        fail: SAVE_HOT_SPOT_REQUEST_FAILED,
    },
    config: saveHotSpotConfig({ hotSpot }),
    hotSpot,
});

const initialState = {
    loadState: LOAD_STATE.SUCCESS,
    data: [],
    error: null,
};

export const hotSpotReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    }),
    [GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: formatApiDataToHotSpots(action.payload.data),
        error: null,
    }),
    [GET_HOT_SPOTS_FOR_CUSTOMER_ID_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: [],
        error: action.payload,
    }),
    [DELETE_HOT_SPOT_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [DELETE_HOT_SPOT_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: state.data.filter(
            deletedHotSpot => deletedHotSpot.id !== action.requestAction.hotSpotId,
        ),
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [DELETE_HOT_SPOT_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [SAVE_HOT_SPOT_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [SAVE_HOT_SPOT_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: getRequestHotSpotData(state, action),
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [SAVE_HOT_SPOT_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
});
